import { render, staticRenderFns } from "./ChangeScopeView.vue?vue&type=template&id=7dfd8318&"
import script from "./ChangeScopeView.vue?vue&type=script&lang=js&"
export * from "./ChangeScopeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports